import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4970abf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "base-form" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"text-align":"right"} }
const _hoisted_11 = {
  key: 0,
  style: {"text-align":"right","line-height":"1rem","margin-top":"1rem","width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Opportunity = _resolveComponent("Opportunity")!
  const _component_el_text = _resolveComponent("el-text")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.viewType == _ctx.ViewType.Creating)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новый автомобиль "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка автомобиля "),
                    (_ctx.originVehicle?.model)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.originVehicle?.model?.manufacturer?.name + ' ' + _ctx.originVehicle?.model?.name), 1))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              (_ctx.viewType == _ctx.ViewType.Creating)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    ref: "form",
                    rules: _ctx.rules,
                    model: _ctx.ruleForm
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Модель автомобиля",
                        "label-position": "top",
                        prop: "model"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_catalog_picker_component, {
                            ref: "vehicleModel",
                            auth: "",
                            modelValue: _ctx.ruleForm.model,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.model) = $event)),
                            placeholder: "Поиск автомобиля по модели или производителю",
                            "search-url": "/api/vehicles/searchmodels",
                            "catalog-tab": _ctx.vehicleModelsCatalogTab,
                            onCatalogItemPicked: _ctx.onVehicleModelPickedFromCatalog
                          }, {
                            label: _withCtx(() => [
                              (_ctx.ruleForm.model?.id)
                                ? (_openBlock(), _createElementBlock("text", _hoisted_6, _toDisplayString(_ctx.ruleForm.model?.manufacturer?.name + ' ' + _ctx.ruleForm.model?.name), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.manufacturer?.name + ' ' + scope.name), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Собственник",
                        "label-position": "top",
                        prop: "counterparty"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_catalog_picker_component, {
                            ref: "counterparty",
                            auth: "",
                            modelValue: _ctx.ruleForm.counterparty,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.counterparty) = $event)),
                            placeholder: "Поиск контрагентов по инициалам, телефону",
                            "search-url": "/api/counterparties/search",
                            "catalog-tab": _ctx.counterpartiesCatalogTab,
                            onCatalogItemPicked: _ctx.onCounterpartyPickedFromCatalog
                          }, {
                            label: _withCtx(() => [
                              (_ctx.ruleForm.counterparty?.id)
                                ? (_openBlock(), _createElementBlock("text", _hoisted_7, _toDisplayString(_ctx.ruleForm.counterparty?.lastname + ' ' + _ctx.ruleForm.counterparty?.firstname + (_ctx.ruleForm.counterparty?.middlename ? ` ${_ctx.ruleForm.counterparty.middlename}` : '')) + " " + _toDisplayString(!!_ctx.ruleForm.counterparty?.legalEntity?.name ? ` (${_ctx.ruleForm.counterparty.legalEntity.name})` : ''), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.lastname + ' ' + scope.firstname + (scope.middlename ? ` ${scope.middlename}` : '')) + " " + _toDisplayString(!!scope.legalEntity?.name ? ` (${scope.legalEntity.name})` : ''), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "VIN",
                        "label-position": "top",
                        prop: "vin"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            maxlength: 50,
                            formatter: _ctx.vinFormatter,
                            modelValue: _ctx.ruleForm.vin,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.vin) = $event)),
                            onKeyup: _withKeys(_ctx.onDecodeVinClick, ["enter"]),
                            placeholder: "VIN"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                underline: false,
                                disabled: !_ctx.isVinCodeValid() || _ctx.isAsyncDecodeVinOperationPending
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, { onClick: _ctx.onDecodeVinClick }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }, 8, ["formatter", "modelValue", "onKeyup"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Гос. номер",
                        "label-position": "top",
                        prop: "govno"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.govNo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.govNo) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Дата производства автомобиля",
                        "label-position": "top",
                        prop: "production"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.ruleForm.productionDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.productionDate) = $event)),
                            clearable: false,
                            format: "DD.MM.YYYY",
                            type: "date",
                            placeholder: "Укажите дату"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Модельный ряд (год)",
                        "label-position": "top",
                        prop: "modelYear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _ctx.ruleForm.modelYear,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.modelYear) = $event)),
                            controls: false,
                            min: 1900,
                            max: _ctx.nowYear
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Двигатель",
                        "label-position": "top",
                        prop: "productionYear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.engine,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.engine) = $event)),
                            rows: 2,
                            type: "textarea",
                            maxlength: "255",
                            placeholder: "Двигатель",
                            resize: "none",
                            clearable: "",
                            "show-word-limit": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Трансмиссия",
                        "label-position": "top",
                        prop: "productionYear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.transmission,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.transmission) = $event)),
                            rows: 2,
                            type: "textarea",
                            maxlength: "255",
                            placeholder: "Трансмиссия",
                            resize: "none",
                            clearable: "",
                            "show-word-limit": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.onFormSubmitClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Создать ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createTextVNode("   "),
                                  _createVNode(_component_el_button, {
                                    type: "warning",
                                    onClick: _ctx.onFormCancelClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Очистить форму ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["rules", "model"])), [
                    [_directive_loading, _ctx.isAsyncOperationPending]
                  ])
                : _createCommentVNode("", true),
              (_ctx.viewType == _ctx.ViewType.Editing)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                    key: 1,
                    ref: "form",
                    rules: _ctx.rules,
                    model: _ctx.ruleForm
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Модель автомобиля",
                        "label-position": "top",
                        prop: "model"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_catalog_picker_component, {
                            disabled: _ctx.ruleForm.ownerWasChanged,
                            ref: "vehicleModel",
                            auth: "",
                            modelValue: _ctx.ruleForm.model,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.model) = $event)),
                            placeholder: "Поиск автомобиля по модели или производителю",
                            "search-url": "/api/vehicles/searchmodels",
                            "catalog-tab": _ctx.vehicleModelsCatalogTab,
                            onCatalogItemPicked: _ctx.onVehicleModelPickedFromCatalog
                          }, {
                            label: _withCtx(() => [
                              (_ctx.ruleForm.model?.id)
                                ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString(_ctx.ruleForm.model?.manufacturer?.name + ' ' + _ctx.ruleForm.model?.name), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.manufacturer?.name + ' ' + scope.name), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue", "catalog-tab", "onCatalogItemPicked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Собственник",
                        "label-position": "top",
                        prop: "counterparty"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_catalog_picker_component, {
                            disabled: _ctx.ruleForm.ownerWasChanged,
                            ref: "counterparty",
                            auth: "",
                            modelValue: _ctx.ruleForm.counterparty,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.counterparty) = $event)),
                            placeholder: "Поиск контрагентов по инициалам, телефону",
                            "search-url": "/api/counterparties/search",
                            "catalog-tab": _ctx.counterpartiesCatalogTab,
                            onCatalogItemPicked: _ctx.onCounterpartyPickedFromCatalog
                          }, {
                            label: _withCtx(() => [
                              (_ctx.ruleForm.counterparty?.id)
                                ? (_openBlock(), _createElementBlock("text", _hoisted_9, _toDisplayString(_ctx.ruleForm.counterparty?.lastname + ' ' + _ctx.ruleForm.counterparty?.firstname + (_ctx.ruleForm.counterparty?.middlename ? ` ${_ctx.ruleForm.counterparty.middlename}` : '')) + " " + _toDisplayString(!!_ctx.ruleForm.counterparty?.legalEntity?.name ? ` (${_ctx.ruleForm.counterparty.legalEntity.name})` : ''), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.lastname + ' ' + scope.firstname + (scope.middlename ? ` ${scope.middlename}` : '')) + " " + _toDisplayString(!!scope.legalEntity?.name ? ` (${scope.legalEntity.name})` : ''), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue", "catalog-tab", "onCatalogItemPicked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "VIN",
                        "label-position": "top",
                        prop: "vin"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: _ctx.ruleForm.ownerWasChanged || _ctx.isAsyncDecodeVinOperationPending,
                            maxlength: 50,
                            formatter: _ctx.vinFormatter,
                            modelValue: _ctx.ruleForm.vin,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.vin) = $event)),
                            placeholder: "VIN"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                underline: false,
                                disabled: _ctx.ruleForm.vin == _ctx.originVehicle?.vin || !_ctx.isVinCodeValid() || _ctx.isAsyncDecodeVinOperationPending
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, { onClick: _ctx.onDecodeVinClick }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }, 8, ["disabled", "formatter", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Гос. номер",
                        "label-position": "top",
                        prop: "govno"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.govNo,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.govNo) = $event)),
                            disabled: _ctx.ruleForm.ownerWasChanged
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Дата производства автомобиля",
                        "label-position": "top",
                        prop: "production"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            disabled: _ctx.ruleForm.ownerWasChanged,
                            modelValue: _ctx.ruleForm.productionDate,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.productionDate) = $event)),
                            clearable: false,
                            type: "date",
                            format: "DD.MM.YYYY",
                            placeholder: "Укажите дату"
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Модельный ряд (год)",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            disabled: _ctx.ruleForm.ownerWasChanged,
                            modelValue: _ctx.ruleForm.modelYear,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.modelYear) = $event)),
                            controls: false,
                            min: 1900,
                            max: _ctx.nowYear
                          }, null, 8, ["disabled", "modelValue", "max"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Двигатель",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.engine,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.engine) = $event)),
                            rows: 2,
                            type: "textarea",
                            maxlength: "255",
                            placeholder: "Двигатель",
                            resize: "none",
                            clearable: "",
                            "show-word-limit": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Трансмиссия",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.transmission,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ruleForm.transmission) = $event)),
                            rows: 2,
                            type: "textarea",
                            maxlength: "255",
                            placeholder: "Трансмиссия",
                            resize: "none",
                            clearable: "",
                            "show-word-limit": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Текущий пробег (км)",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            disabled: _ctx.ruleForm.ownerWasChanged,
                            modelValue: _ctx.ruleForm.mileage,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ruleForm.mileage) = $event)),
                            min: 0,
                            controls: false
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            label: "Новый собственник",
                            modelValue: _ctx.ruleForm.ownerWasChanged,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ruleForm.ownerWasChanged) = $event)),
                            onChange: _ctx.onFormOwnerChangedChange
                          }, null, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.onFormSubmitClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Сохранить ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_el_button, {
                                    type: "warning",
                                    onClick: _ctx.onFormCancelClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Отменить изменения ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: !_ctx.isViewLoaded && _ctx.isAsyncOperationPending || !_ctx.isVehicleDeletionAllowed,
                                      onClick: _ctx.onDeleteVehicleClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить автомобиль ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("   ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  (_ctx.isViewLoaded && !_ctx.isVehicleDeletionAllowed)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_el_text, {
                                          type: "info",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Opportunity)
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" Нельзя удалить - по автомобилю проводились работы в заказ-нарядах ")
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["rules", "model"])), [
                    [_directive_loading, _ctx.isAsyncOperationPending]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}